<template>
  <div class="signup">
    <slot v-if="direction">
      <div class="max-w-5xl mx-auto">
        <component
          v-bind:is="direction"
          :serviceUrl="serviceUrl"
          :invitation="invitation"
          :recaptchaSiteKey="recaptchaSiteKey"
          @startOver="startOver"
        />
      </div>
    </slot>
    <div v-else class="max-w-3xl mx-auto mt-6 md:mt-12">
      <center class="text-2xl my-4">Welcome to TruckerZoom</center>
      <div class="w-full md:w-[420px] mx-auto px-4">
        <div v-show="!invitation.open">
          <center class="text-base mb-8 text-gray-500">
            Choose the type of company
          </center>
          <button
            class="choose-type recaptcha-btn"
            @click="chooseTrucker"
            disabled
          >
            <div class="flex items-center gap-6">
              <svg
                width="40"
                height="40"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1480_38060)">
                  <path
                    d="M3.57143 0.5H46.4286C48.1249 0.5 49.5 1.87513 49.5 3.57143V46.4286C49.5 48.1249 48.1249 49.5 46.4286 49.5H3.57143C1.87513 49.5 0.5 48.1249 0.5 46.4286V3.57143C0.5 1.87513 1.87513 0.5 3.57143 0.5Z"
                    fill="white"
                    stroke="currentColor"
                  />
                  <mask
                    id="mask0_1480_38060"
                    style="mask-type: luminance"
                    maskUnits="userSpaceOnUse"
                    x="8"
                    y="8"
                    width="35"
                    height="35"
                  >
                    <path d="M42.6939 8H8V42.6939H42.6939V8Z" fill="white" />
                  </mask>
                  <g mask="url(#mask0_1480_38060)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M26.8712 17.8287H5.49365V14.9375H28.1722C29.0504 14.9375 29.7623 15.6494 29.7623 16.5277V20.7671H35.3489C36.9221 20.7671 38.3355 21.7167 38.9339 23.1737L38.935 23.1764L40.7633 27.6552C41.5143 28.2163 42.0075 29.0714 42.1086 30.0173L42.1088 30.0199L42.4545 33.1624L42.4549 33.1656C42.5829 34.356 41.7315 35.4341 40.5341 35.5763C40.409 35.593 40.3031 35.5921 40.2788 35.5919H40.2747H37.7306C37.6668 35.5919 37.6041 35.5873 37.5428 35.5784C36.9885 37.1467 35.4938 38.2689 33.7346 38.2689C31.9994 38.2689 30.5215 37.1771 29.9496 35.6424C29.9259 35.6437 29.902 35.6443 29.8779 35.6443H28.4664H18.4389C17.9068 37.1231 16.4924 38.1792 14.8292 38.1792C13.1465 38.1792 11.7184 37.0981 11.2011 35.5919H7.88769C7.16916 35.5919 6.58667 35.0094 6.58667 34.2909C6.58667 33.5724 7.16916 32.9898 7.88769 32.9898H11.2391C11.7859 31.5391 13.1862 30.5084 14.8292 30.5084C16.492 30.5084 17.9061 31.564 18.4385 33.0423H26.8712V17.8287ZM29.7674 27.2688V23.3691H35.3489C35.8633 23.3691 36.3276 23.678 36.5267 24.1614L36.5271 24.1625L37.7899 27.2562H35.7686H34.4676V27.2688H29.7674ZM33.7346 32.3609C32.7003 32.3609 31.8648 33.1964 31.8648 34.2307C31.8648 35.265 32.7003 36.1006 33.7346 36.1006C34.7689 36.1006 35.6044 35.265 35.6044 34.2307C35.6044 33.1964 34.7689 32.3609 33.7346 32.3609ZM14.8292 32.6768C13.907 32.6768 13.1621 33.4216 13.1621 34.3438C13.1621 35.2661 13.907 36.0109 14.8292 36.0109C15.7515 36.0109 16.4963 35.2661 16.4963 34.3438C16.4963 33.4216 15.7515 32.6768 14.8292 32.6768Z"
                      fill="currentColor"
                    />
                    <path
                      d="M11.8057 22.6729H23.3564"
                      stroke="currentColor"
                      stroke-width="2.83333"
                    />
                  </g>
                </g>
                <defs>
                  <clipPath id="clip0_1480_38060">
                    <rect width="50" height="50" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <div class="flex flex-col justify-center">
                <b>TRUCK CARRIER TMS</b>
                <small>DRAYAGE, TL, LTL</small>
              </div>
              <div class="grow" />
              <svg
                class="check"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.071 14.1924L5.47488 9.59625L5.12133 9.24268L4.76778 9.59625L3.35356 11.0104L3 11.364L3.35356 11.7175L9.71752 18.0815L10.071 18.4349L10.4246 18.0815L21.0312 7.47487L21.3847 7.12132L21.0312 6.76776L19.617 5.35355L19.2634 5L18.9099 5.35355L10.071 14.1924Z"
                  fill="#254EDB"
                  stroke="#254EDB"
                />
              </svg>
            </div>
          </button>
          <button
            class="choose-type recaptcha-btn"
            @click="chooseClient"
            disabled
          >
            <div class="flex items-center gap-6">
              <svg
                width="40"
                height="40"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1480_38105)">
                  <path
                    d="M5.61224 0.5H44.3878C47.2112 0.5 49.5 2.78883 49.5 5.61224V44.3878C49.5 47.2112 47.2112 49.5 44.3878 49.5H5.61224C2.78883 49.5 0.5 47.2112 0.5 44.3878V5.61224C0.5 2.78883 2.78883 0.5 5.61224 0.5Z"
                    fill="white"
                    stroke="currentColor"
                  />
                  <path
                    d="M20 15.125H27.488C27.962 15.125 28.4027 15.3693 28.654 15.7713L33.4063 23.375H39.4669C39.8466 23.375 40.1544 23.6829 40.1544 24.0625C40.1544 24.1776 40.1255 24.2908 40.0705 24.3917L34.6251 32.875H33.75C33.0205 32.875 32.3129 32.7803 31.6391 32.6025L35.9913 26.125H12.3L13.7415 32.633C13.1037 32.7912 12.4367 32.875 11.75 32.875H11L9.2947 24.996C9.1589 24.2488 9.6545 23.533 10.4016 23.3972C10.4828 23.3825 10.5651 23.375 10.6476 23.375H11.75V16.5C11.75 15.7407 12.3656 15.125 13.125 15.125H14.5V11H20V15.125ZM14.5 23.375H30.1633L26.7258 17.875H14.5V23.375ZM11.75 35.625C13.863 35.625 15.7905 34.8307 17.25 33.5243C18.7096 34.8307 20.6371 35.625 22.75 35.625C24.863 35.625 26.7905 34.8307 28.25 33.5243C29.7096 34.8307 31.6371 35.625 33.75 35.625H36.5V38.375H33.75C31.7465 38.375 29.868 37.8393 28.25 36.9034C26.6321 37.8393 24.7535 38.375 22.75 38.375C20.7464 38.375 18.868 37.8393 17.25 36.9034C15.6321 37.8393 13.7536 38.375 11.75 38.375H9V35.625H11.75Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1480_38105">
                    <rect width="50" height="50" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <div class="flex flex-col justify-center">
                <b>BROKER, NVOCC, 3PL</b>
              </div>
              <div class="grow" />
              <svg
                class="check"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.071 14.1924L5.47488 9.59625L5.12133 9.24268L4.76778 9.59625L3.35356 11.0104L3 11.364L3.35356 11.7175L9.71752 18.0815L10.071 18.4349L10.4246 18.0815L21.0312 7.47487L21.3847 7.12132L21.0312 6.76776L19.617 5.35355L19.2634 5L18.9099 5.35355L10.071 14.1924Z"
                  fill="#254EDB"
                  stroke="#254EDB"
                />
              </svg>
            </div>
          </button>
          <center class="my-4">
            <button
              class="invitation-btn recaptcha-btn"
              @click="invitation.open = true"
              disabled
            >
              Have an invitation code?
            </button>
          </center>
        </div>
        <div v-show="invitation.open">
          <center class="text-base mb-8 text-gray-500">
            Enter the invitation code
          </center>
          <div class="invitation-form">
            <el-form label-position="top" size="small">
              <div class="flex flex-col gap-2">
                <center class="red" v-if="invitation.error">
                  {{ invitation.error }}
                </center>
                <el-form-item>
                  <div class="el-input-inner-label">
                    <label>
                      <div class="w-36 leading-6 text-sm">Invitation Code</div>
                    </label>
                    <el-input
                      v-model="invitation.code"
                      class="code-input recaptcha-btn"
                      @blur="verifyInvitation"
                    />
                  </div>
                </el-form-item>
                <el-form-item>
                  <div class="flex items-center justify-between">
                    <el-button
                      type="primary"
                      size="small"
                      class="w-40"
                      :icon="invitation.verifying ? 'el-icon-loading' : null"
                      :disabled="!isVerifiable"
                      @click="verifyInvitation"
                    >
                      {{
                        invitation.verifying ? "Verifying" : "Verify & Continue"
                      }}
                    </el-button>
                    <a class="cancel" @click="resetInvitation"> Cancel </a>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
        <e-recaptcha
          ref="recaptcha"
          action="signup"
          :site-key="recaptchaSiteKey"
          @ready="onRecaptchaReady"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Trucker from "@/default/pages/signups/trucker/index.vue";
import Client from "@/default/pages/signups/client/index.vue";
export default {
  name: "ClientSignup",
  components: { Trucker, Client },
  props: {
    serviceUrl: {
      type: String,
      required: true,
    },
    recaptchaSiteKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      direction: null,
      invitation: {
        open: false,
        code: null,
        tenant: null,
        error: null,
        verifying: false,
      },
    };
  },
  computed: {
    isVerifiable() {
      return this.invitation.code && this.invitation.code.length > 0;
    },
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("invited") === "true") this.invitation.open = true;
  },
  methods: {
    chooseTrucker() {
      this.direction = Trucker;
    },
    chooseClient() {
      this.direction = Client;
    },
    startOver() {
      this.resetInvitation();
      this.direction = null;
      const url = new URL(window.location.href);
      url.search = "";
      window.history.replaceState({}, "", url);
    },
    resetInvitation() {
      this.invitation = {
        open: false,
        code: null,
        tenant: null,
        error: null,
      };
    },
    async verifyInvitation() {
      try {
        if (!this.invitation.code) return;
        this.invitation.verifying = true;
        const recaptcha_token = await this.$refs.recaptcha.getToken(
          "carrier_invitation_verify",
        );
        const response = await this.$http.post(
          "/api/broker/carrier_invitations/verify",
          {
            code: this.invitation.code.toUpperCase(),
            recaptcha_token,
          },
        );
        this.invitation.tenant = response.data;
        this.chooseTrucker();
      } catch (error) {
        this.invitation.error = error.response?.data?.errors || error.message;
      } finally {
        this.invitation.verifying = false;
      }
    },
    onRecaptchaReady() {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("directory") === "true") this.chooseTrucker();
      if (urlParams.get("broker") === "true") this.chooseClient();
    },
  },
};
</script>
<style lang="scss" scoped>
.signup {
  button.choose-type {
    @apply block border border-gray-300 w-full rounded my-4 p-4 text-left text-gray-400 hover:text-blue-700 hover:border-blue-700 hover:bg-slate-50;
    b {
      @apply text-sm leading-5 text-black font-normal block #{!important};
    }
    small {
      @apply text-xs text-gray-500;
    }
    .check {
      @apply hidden;
    }
    &:hover {
      .check {
        @apply block;
      }
    }
  }
  .invitation-btn {
    @apply text-blue-500 hover:text-blue-600 hover:underline;
  }
  .invitation-form::v-deep {
    @apply border border-blue-300 p-4 rounded bg-slate-50;
    .el-form-item {
      @apply m-0;
    }
    .code-input {
      .el-input__inner {
        @apply text-lg text-center uppercase #{!important};
        &:disabled {
          @apply bg-gray-100;
        }
      }
    }
  }
}
</style>
